import React from 'react';
import { FaHeart } from 'react-icons/fa';

const Footer = ({ onOpenAIVoiceModal }) => {
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Aura', href: 'https://www.aurasos.com/en-us' },
    { name: 'Ornico-Group', href: 'https://ornico.co/' },
    { name: 'Orange DRC', href: 'https://www.orange.cd/' },
    { name: 'Research', href: '/research' },
    { name: 'Experience', href: '/experience' },
    { name: 'Contact', href: '/contact' },
  ];

  const professionalLinks = [
    { name: 'LinkedIn', href: 'https://www.linkedin.com/in/reagan-scofield-mukandila-603287b5/' },
    { name: 'GitHub', href: 'https://github.com/reaganscofield' },
    { name: 'Dev.to', href: 'https://dev.to/reaganscofield' },
  ];

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-sky-900 to-slate-900 border-t border-gray-700/50">
      <div className="container mx-auto px-6 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          
          {/* About Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent">
              Reagan Scofield
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Committed to building autonomous technologies that turn abstract ideas into tangible results, specifically focusing on creating intuitive, intelligent systems that bridge the gap between human intent and automated execution.
            </p>
            <div className="space-x-2 text-gray-400 text-sm ">
              <span>📍</span>
              <span>Open to Work</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    target={link.href.startsWith('http') ? '_blank' : ''} 
                    rel={link.href.startsWith('http') ? 'noopener noreferrer' : ''}
                    className="text-gray-300 hover:text-cyan-400 transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Professional Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Professional</h4>
            <ul className="space-y-2">
              {professionalLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-cyan-400 transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Get In Touch</h4>
            <div className="space-y-2">
              <a 
                href="mailto:reaganscofield@outlook.com"
                className="text-gray-300 hover:text-cyan-400 transition-colors duration-300 text-sm block"
              >
                📧 reaganscofield@outlook.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700/50 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Reagan Scofield. All rights reserved.
            </div>
            
            {/* Tech Stack */}
     
            
            {/* Quick Actions */}
            <div className="flex space-x-4">
              <button
                type="button"
                onClick={onOpenAIVoiceModal}
                className="px-4 py-2 bg-gradient-to-r from-cyan-500 to-purple-500 text-white text-sm font-medium rounded-lg hover:from-cyan-400 hover:to-purple-400 transition-all duration-300"
              >
                AI Assistant
              </button>
              <a 
                href="/contact"
                className="px-4 py-2 bg-gradient-to-r from-cyan-500 to-purple-500 text-white text-sm font-medium rounded-lg hover:from-cyan-400 hover:to-purple-400 transition-all duration-300"
              >
                Hire Me
              </a>
              <a 
                href="pdfs/reagan-cv.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 border border-cyan-400 text-cyan-400 text-sm font-medium rounded-lg hover:bg-cyan-400 hover:text-slate-900 transition-all duration-300"
              >
                Download CV
              </a>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        {/* <div className="mt-8 text-center">
          <div className="inline-flex items-center space-x-4 text-gray-500 text-xs">
            <span>🚀 Open to opportunities</span>
            <span>•</span>
            <span>🌟 Available for freelance</span>
            <span>•</span>
            <span>💡 Always learning</span>
          </div>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
